import { coreDefaultTheme } from '@kite-js/theme';
import { ULTheme, ULThemeBuilder } from '@theme/types';

const AgodaThemeBuilder: ULThemeBuilder = (cultureCode?: string, appId?: string) => {
    const theme: ULTheme = {
        ...coreDefaultTheme,
        logoUrl: 'https://cdn6.agoda.net/images/MVC/default/agoda-logo-booking-page@2x.png',
        background: {
            image:
                'url(https://cdn6.agoda.net/images/MVC/default/background_image/illustrations/bg-agojis-1920x730.png), linear-gradient(180deg, #79c1cc, #bee0d0)',
            position: 'center bottom',
            size: 'contain',
        },
        faviconUrl: 'https://www.agoda.com/favicon.ico',
        input: {
            ...coreDefaultTheme.input,
            borderRadius: 'S',
        },
        tab: {
            ...coreDefaultTheme.tab,
            padding: '12px 8px 12px 8px',
        },
    };

    // TODO: this is not good, but I use it for around for MSPA
    // please, unify and remove when we take over MSPA login 💪
    if (appId === 'mspa') {
        theme.background = {
            image: 'url(https://cdn6.agoda.net/images/mobile/bg_mspa.jpg)',
            position: '0 0',
            size: '100% 100%',
        };
    }

    return theme;
};

export default AgodaThemeBuilder;
